<template>
  <vx-input-group append-classes="i8n-textarea justify-bottom">
    <Mentionable
      :keys="['@']"
      :items="items"
      @search="loadIssues($event)"
      @mentioned="mentioned($event)"
      offset="6"
      insert-space
    >
      <textarea 
        class="w-full vs-inputx vs-input--input normal" 
        style="height:200px;font-family: Arial;line-height: 1.5rem;" 
        spellcheck="false" 
        v-model="i8nContent" 
        :placeholder="placeholder" />

        <template #no-result>
          {{ loading ? 'Loading...' : 'No result' }}
        </template>
    </Mentionable>
      

    <div slot="append">
        <vs-dropdown vs-trigger-click class="cursor-pointer items-per-page-handler">
          <div style="padding: 0.8rem !important;" class="ml-2 mr-2 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <img class="h-4 w-5" :src="i18n_locale_img" :alt="locale" />
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu class="w-48">
            <vs-dropdown-item @click="updateLocale('eng')">
              <img
                class="h-4 w-5 mr-1"
                src="@/assets/images/flags/eng.png"
                alt="eng"
                />
                &nbsp;English
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('dan')">
              <img
                class="h-4 w-5 mr-1"
                src="@/assets/images/flags/dan.png"
                alt="eng"
                />
                &nbsp;Danish
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('swe')">
              <img
                class="h-4 w-5 mr-1"
                src="@/assets/images/flags/swe.png"
                alt="eng"
                />
                &nbsp;Swedish
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('nor')">
              <img
                class="h-4 w-5 mr-1"
                src="@/assets/images/flags/nor.png"
                alt="eng"
                />
                &nbsp;Norwegian
            </vs-dropdown-item>
            <vs-dropdown-item @click="updateLocale('fin')">
              <img
                class="h-4 w-5 mr-1"
                src="@/assets/images/flags/fin.png"
                alt="eng"
                />
                &nbsp;Finnish
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
    </div>
  </vx-input-group>
</template>

<script>
import { Mentionable } from '@/components/mention'
import VxImportGroup from "@/components/vx-input-group/VxInputGroup";

export default {
  name: "i8n-textarea-mention",
  components: {
    Mentionable,
    VxImportGroup,
  },
  props: {
    placeholder: String,
    content: [String, Object],
    mentions: Array,
  },
  data() {
    return {
      locale: 'eng',
      i8nContent: '',

      items: [],
      loading: false,
    };
  },
  watch: {
    locale() {
        this.i8nContent = this.content[this.locale];
    },
    i8nContent() {
        let clonedContent = { ...this.content };
        clonedContent[this.locale] = this.i8nContent;

        this.$emit('update:content', clonedContent);
    },
    content() {
       this.i8nContent = this.content[this.locale];
    }
  },
  computed: {
    i18n_locale_img() {
      return require(`@/assets/images/flags/${this.locale}.png`);
    }
  },
  methods: {
    updateLocale(locale) {
      this.locale = locale;
    },

    mentioned (item) {
      this.mentions.push(item);

      console.log(this.mentions);
    },

    async fetchIssues (searchText = null) {
      const url = process.env.VUE_APP_API +'/Tags?query=' + searchText;

      this.$http.get(url)
        .then(resp => {
          this.items = resp.data;
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        });
    },

    async loadIssues (searchText = null) {
      console.log('Search:', searchText);
      this.loading = true
      await this.fetchIssues(searchText)
      //this.loading = false
    }
  },
  mounted() {
    let contentType = typeof this.content;
    if (contentType === "string" || contentType === "undefined" || this.content === null) {
        let newContent = {
            eng: "",
            dan: "",
            swe: "",
            nor: "",
            fin: ""
        };
        this.$emit('update:content', newContent);

        this.i8nContent = "";

        return;
    }

    this.i8nContent = this.content[this.locale];
  }
};
</script>
<style lang="scss">
.vs-dropdown-menu.w-48 {
    z-index: 1000000;
}

.i8n-textarea.justify-bottom {
    align-items: flex-start;
}

.tooltip {
  z-index: 2000000;

  &:hover {
    cursor: pointer;
  }
 
  &.popover {
    $color: #f9f9f9;
 
    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, .1);
    }
 
    .popover-arrow {
      border-color: $color;
      cursor: pointer;
    }
  }
}

.tooltip-arrow {
  z-index: 1;
  cursor: pointer;
}

.mention-item {
  padding: 4px 10px;
  border-radius: 4px;
}

.mention-selected {
  background: rgb(192, 250, 153);
}
</style>